// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1p-6";
export var headerCell = "_1p-2";
export var rowWrapper = "_1p-4";
export var stickyAggregationCell = "_1p-a";
export var stickyAggregationRow = "_1p-7";
export var stickyColumnCell = "_1p-9";
export var stickyColumnHeaderCell = "_1p-8";
export var table = "_1p-1";
export var virtualRowWrapper = "_1p-5";
export var virtualTableContainer = "_1p-0";
export var white = "_1p-3";